<template>
  <div>
    <vx-card
      title="LR Search"
      class="lrsearch"
      card-background="success"
      content-color="#fff"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="vx-row">
            <div class="vx-col md:w-1/3 sm:w-1/3 w-full mt-4">
              <vs-input
                class="flex lrsearchtextbox"
                v-model="searchLrNo"
                placeholder="Lr No"
                v-validate="'required|digits'"
                data-vv-validate-on="input|keyup|blur|click"
                v-on:keyup.enter="getLrDetails"
              />
            </div>
            <div
              class="vx-col md:w-1/3 sm:w-1/3 w-full"
              style="width: 23% !important"
            >
              <vs-button
                icon-pack="material-icons"
                icon="search"
                class="mt-4"
                @click="getLrDetails"
                >Search</vs-button
              >
            </div>
            <div
              class="vx-col md:w-1/3 sm:w-1/3 w-full mt-3"
              v-if="lrDataFound"
            >
              <div class="flex flex-wrap">
                <div class="btn-group">
                  <vx-tooltip text="Print LR" position="top">
                    <vs-button
                      @click="showLr"
                      class="w-1/2 h-12 flex"
                      size="large"
                      radius
                      color="primary"
                      type="border"
                      icon-pack="material-icons"
                      icon="api"
                    ></vs-button>
                  </vx-tooltip>
                </div>

                <div class="btn-group ml-2">
                  <vx-tooltip
                    text="Print Freight"
                    position="top"
                    v-if="
                      lrDetails.toBranchId == branchId ||
                      sessionRoleId == 1 ||
                      sessionRoleId == 2
                    "
                  >
                    <vs-button
                      @click="showFreight"
                      class="w-1/2 h-12 flex"
                      size="large"
                      radius
                      color="primary"
                      type="border"
                      icon-pack="material-icons"
                      icon="price_change"
                    ></vs-button>
                  </vx-tooltip>
                </div>

                <div class="btn-group ml-2">
                  <vx-tooltip text="Copy Lr Details" position="top">
                    <vs-button
                      @click="copyLr"
                      class="w-1/2 h-12 flex"
                      size="large"
                      radius
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-copy"
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full"></div>
      </div>
    </vx-card>

    <div class="vx-row" v-if="lrDataFound">
      <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
        <vx-card title="Basic Details" class="m-3">
          <div class="vx-row">
            <div class="vx-col flex-1">
              <table>
                <tr>
                  <td class="font-semibold">From</td>
                  <td>{{ lrDetails.consignmentFromBranchName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Booking <br />Type</td>
                  <td>{{ lrDetails.consignmentBookingPaymentTypeName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Eway Bill <br />
                    No
                  </td>
                  <td>{{ lrDetails.consignmentEwayBillNo }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Booked <br />
                    Date
                  </td>
                  <td>{{ lrDetails.consignmentBookedDate | date(true) }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Freight <br />
                    Date
                  </td>
                  <td>
                    {{ lrDetails.consignmentFreightOn | date(true) }}
                  </td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 1 -->

            <!-- Information - Col 2 -->
            <div class="vx-col flex-1">
              <table>
                <tr>
                  <td class="font-semibold">To</td>
                  <td>{{ lrDetails.consignmentToBranchName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">P.Invoice No</td>
                  <td>{{ lrDetails.consignmentProductInvoiceNo }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Product <br />Value</td>
                  <td>{{ lrDetails.consignmentProductValue }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Booked <br />
                    By
                  </td>
                  <td>{{ lrDetails.consignmentCreatedUser }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Freight <br />
                    By
                  </td>
                  <td>{{ lrDetails.consignmentFrieghtAddedUser || "--" }}</td>
                </tr>
              </table>
            </div>
            <!-- Information - Col 2 -->
            <div class="vx-col flex-1">
              <table>
                <tr>
                  <td class="font-semibold">C Branch</td>
                  <td>{{ lrDetails.consignmentCurrentBranch }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Consignment Status</td>
                  <td>{{ lrDetails.consignmentStatusName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Payment Status</td>
                  <td>{{ lrDetails.consignmentPaymentStatusName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Paid Through</td>
                  <td>{{ lrDetails.paymentPaidThroughText }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Payment RefNo</td>
                  <td>{{ lrDetails.paymentRefNo || "--" }}</td>
                </tr>
              </table>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-1/2 w-full" style="padding: 0 1rem">
        <vx-card title="Package Details" class="m-3">
          <vs-table max-items="3" stripe pagination :data="lrDetails.packages">
            <template slot="thead">
              <vs-th>S No</vs-th>
              <vs-th>Consignment Type</vs-th>
              <vs-th>Quantity</vs-th>
              <vs-th>Total Weight (Kgs)</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>{{ indextr + 1 }}</vs-td>
                <vs-td :data="data[indextr].consignmentPackageTypeName">{{
                  data[indextr].consignmentPackageTypeName
                }}</vs-td>
                <vs-td :data="data[indextr].consignmentPackageQuantity">{{
                  data[indextr].consignmentPackageQuantity
                }}</vs-td>
                <vs-td :data="data[indextr].consignmentPackageWeight">{{
                  data[indextr].consignmentPackageWeight
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div
        class="vx-row m-3"
        style="margin-bottom: 0.2rem !important; width: 100%"
      >
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Consignor">
            <table>
              <tr>
                <td class="font-semibold">Name :</td>
                <td>
                  {{ lrDetails.consignor.consignmentConsignorName }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile :</td>
                <td>
                  {{
                    lrDetails.consignor.consignmentConsignorMobileNo || " -- "
                  }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">GST No :</td>
                <td>
                  {{ lrDetails.consignor.consignmentConsignorGstNo || " -- " }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Address :</td>
                <td>
                  {{
                    lrDetails.consignor.consignmentConsignorAddress || " -- "
                  }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Consignee">
            <table>
              <tr>
                <td class="font-semibold">Name :</td>
                <td>
                  {{ lrDetails.consignee.consignmentConsigneeName }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile :</td>
                <td>
                  {{
                    lrDetails.consignee.consignmentConsigneeMobileNo || " -- "
                  }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">GST No:</td>
                <td>
                  {{ lrDetails.consignee.consignmentConsigneeGstNo || " -- " }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Address :</td>
                <td>
                  {{ lrDetails.consignee.consignmentConsigneeAddress || "--" }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>
      <div
        class="vx-row m-3"
        style="margin-bottom: 0.75rem !important; width: 100%"
      >
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Payment Details">
            <div
              class="vx-row"
              v-if="
                lrDetails.toBranchId == branchId ||
                sessionRoleId == 1 ||
                sessionRoleId == 2
              "
            >
              <div class="vx-col flex-1 w-1/2">
                <table>
                  <tr>
                    <td class="font-semibold">Freight Charge</td>
                    <td>{{ lrDetails.consignmentFreightCharge || 0 }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Hamali Charge</td>
                    <td>{{ lrDetails.consignmentHamaliCharge || 0 }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Stationary Charge</td>
                    <td>{{ lrDetails.consignmentStationaryCharge || 0 }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Collection Charge</td>
                    <td>{{ lrDetails.consignmentCollectionCharges || 0 }}</td>
                  </tr>
                </table>
              </div>
              <div class="vx-col flex-2 w-1/2">
                <table>
                  <tr>
                    <td class="font-semibold">DD Charge</td>
                    <td>{{ lrDetails.consignmentDoorDeliveryCharge || 0 }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">LR Charge</td>
                    <td>{{ lrDetails.consignmentLrCopyCharge || 0 }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">UnLoading Charge</td>
                    <td>{{ lrDetails.consignmentLrCopyCharge || 0 }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Other Charge</td>
                    <td>{{ lrDetails.consignmentOtherCharge || 0 }}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div v-else>
              <vs-alert icon-pack="feather">
                Unauthorized to see the payment Details
              </vs-alert>
            </div>
          </vx-card>
        </div>
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Collection Details">
            <vs-table :data="lrDetails.collections">
              <template slot="thead">
                <vs-th>Agent Name</vs-th>
                <vs-th>Sent Date</vs-th>
                <vs-th>Updated Date</vs-th>
                <vs-th>Status</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].collectionAgentName">
                    {{ data[indextr].collectionAgentName }}
                  </vs-td>
                  <vs-td :data="data[indextr].createdOn">
                    {{ data[indextr].createdOn | date(true) }} by
                    {{ data[indextr].collectionCreatedUser }}
                  </vs-td>
                  <vs-td :data="data[indextr].modifiedOn">
                    {{ data[indextr].modifiedOn | date(true) }} by
                    {{ data[indextr].collectionUpdatedUser }}
                  </vs-td>
                  <vs-td :data="data[indextr].collectionStatus">
                    <span v-if="data[indextr].collectionStatus == 1">
                      Sent for Collection
                    </span>
                    <span v-else-if="data[indextr].collectionStatus == 2">
                      Not Paid
                    </span>
                    <span v-else-if="data[indextr].collectionStatus == 3">
                      Not Paid Went for Another Collection
                    </span>
                    <span v-else-if="data[indextr].collectionStatus == 4">
                      Paid
                    </span>
                    <span v-else> -- </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      <div
        class="vx-row m-3"
        style="margin-bottom: 4rem !important; width: 100%"
      >
        <div class="vx-col w-full" style="padding: 0 5px">
          <vx-card title="Shipment Track">
            <vs-table :data="lrDetails.consignmentTrips">
              <template slot="thead">
                <vs-th>Trip Location</vs-th>
                <vs-th>Intial Comment</vs-th>
                <vs-th>Final Comment</vs-th>
                <vs-th>Vehicle No</vs-th>
                <vs-th>Start Date</vs-th>
                <vs-th>Reached Date</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].fromBranchName">
                    {{ data[indextr].fromBranchName }} -
                    {{ data[indextr].toBranchName }}
                  </vs-td>
                  <vs-td :data="data[indextr].consignmentTripInitalComment">
                    {{ data[indextr].consignmentTripInitalComment }}
                  </vs-td>

                  <vs-td :data="data[indextr].consignmentTripFinalComment">
                    {{ data[indextr].consignmentTripFinalComment }}
                  </vs-td>

                  <vs-td :data="data[indextr].VehicleNo">
                    {{ data[indextr].VehicleNo }}
                  </vs-td>
                  <vs-td :data="data[indextr].tripStartedDate">
                    {{ data[indextr].tripStartedDate | date(true) }}
                  </vs-td>
                  <vs-td :data="data[indextr].tripReachedDate">
                    {{ data[indextr].tripReachedDate | date(true) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    searchLrNo: {
      required: "Please enter your LR No",
      digits: "LR number must be numeric",
    },
  },
};
Validator.localize("en", dict);

export default {
  data() {
    return {
      searchedLr: false,
      searchLrNo: "",
      lrDataFound: false,
      lrDetails: null,
      sessionRoleId: JSON.parse(localStorage.getItem("sstUnData")).roles[0]
        .roleId,
      branchId: JSON.parse(localStorage.getItem("sstUnData")).branchId,
      // pdfUrl: "http://localhost:8081/transport-System/PDF/views/new/",
      pdfUrl: "https://newpdf.srisainadhtransport.in/2024/",
    };
  },
  methods: {
    showLr() {
      const url =
        this.pdfUrl +
        "lrview.php?lrno=" +
        btoa(this.lrDetails.consignmentLrNo) +
        "&token=" +
        localStorage.getItem("sessionToken");
      // alert(url);
      window.open(url, "_blank");
 
    },
    copyLr() {
      const thisIns = this;
      const lrData = this.lrDetails;
      let showedMessage = false;
      let copyString = `Lr No : ${lrData.consignmentLrNo}\nFrom: ${lrData.consignmentFromBranchName}\nTo: ${lrData.consignmentToBranchName}\nStatus: *${lrData.consignmentStatusName}*\nConsignor:${lrData.consignor.consignmentConsignorName} ${lrData.consignor.consignmentConsignorMobileNo}\nConsignee: ${lrData.consignee.consignmentConsigneeName} ${lrData.consignee.consignmentConsigneeMobileNo}\nQuantity:${lrData.consignmentPackagesTotalCnt}`;
      copyString = copyString.toString();
      this.$copyText(copyString).then(function () {
        if (!showedMessage) {
          showedMessage = true;
          thisIns.$vs.notify({
            title: "Success",
            text: "LR Data Copied Successfully",
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        }
      });
    },
    showFreight() {
      if (this.lrDetails.consignmentFreightNo) {
        //code
        const url =
          this.pdfUrl +
          "freightreceiptpdf.php?lrno=" +
          btoa(this.lrDetails.consignmentId) +
          "&token=" +
          localStorage.getItem("sessionToken");
        window.open(url, "_blank");

        //  window.open(
        //   url,
        //   "_blank",
        //   "location=yes,height=570,width=520,scrollbars=yes,status=yes"
        // );
      } else {
        this.$vs.notify({
          title: "Freight was not generated!Please try lateral",
          color: "danger",
          position: "top-right",
        });
      }
    },
    getLrDetails() {
      // alert(this.searchLrNo);
      this.$http
        .get(`portage/lrsearch/${this.searchLrNo}`)
        .then((response) => {
          this.lrDetails = response.data.data;
          console.log(response);
          this.searchedLr = true;
          this.lrDataFound = true;
        })
        .catch((error) => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right",
          });
        });
    },
  },
};
</script>
<style>
.lrsearch .vx-card__body {
  padding: 0px 0px 0.7rem 1.5rem !important;
}
.lrsearchtextbox .vs-inputx {
  color: black !important;
}
</style>